import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { BrandsTemplate } from 'components/Templates'

const Brands: FC = () => {
  return (
    <Layout iconPath={'/icon/white/home.svg'} headline={'ブランド管理'} title={'ブランド管理'}>
      <BrandsTemplate />
    </Layout>
  )
}

export default Brands
